import { endOfDay, isValid, parseISO, startOfDay } from 'date-fns';

/** Calendar days from date inputs ("2026-11-03"); '' leaves that end open. */
export interface DayRange {
  from: string;
  to: string;
}

export const EMPTY_DAY_RANGE: DayRange = { from: '', to: '' };

export const isDayRangeSet = ({ from, to }: DayRange): boolean => Boolean(from || to);

/**
 * The session lists compare start times with exact moments (`$gte dateFrom`,
 * `$lte dateTo`). A bare day would end the range at midnight UTC of its last
 * day and drop everything after, so each day goes out as its start and end in
 * the viewer's own time zone.
 */
export const dayRangeParams = ({ from, to }: DayRange): Record<string, string> => {
  const params: Record<string, string> = {};
  const first = parseISO(from);
  const last = parseISO(to);
  if (from && isValid(first)) params.dateFrom = startOfDay(first).toISOString();
  if (to && isValid(last)) params.dateTo = endOfDay(last).toISOString();
  return params;
};
